import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { MaintenanceApiService } from "./maintenance-api.service";

export function maintenancePlatformGuard({ redirectTo }: { redirectTo?: unknown[] } = {}): CanActivateFn {
    return (route: ActivatedRouteSnapshot) => {
        const maintenance = inject(MaintenanceApiService);
        const router = inject(Router);
        const { skipMaintenanceCheck } = route.queryParams;

        // If the query param explicitly requests skipping maintenance checks,
        // persist that decision in sessionStorage so subsequent navigations honor it.
        if (skipMaintenanceCheck === "1") {
            maintenance.setMaintenanceModeSession(true);
        } else if (skipMaintenanceCheck === "0") {
            maintenance.clearMaintenanceModeSession();
        }

        // If a session flag is present to skip maintenance checks, allow immediately
        if (maintenance.getMaintenanceModeSession()) {
            return true;
        }

        return maintenance.getPlatformMaintenanceMode().pipe(
            map((maintenanceMode) => {
                if (maintenanceMode !== null && maintenanceMode.maintenance) {
                    router.navigate(redirectTo ?? ["platform-maintenance"], { state: { message: maintenanceMode.message } });
                    return false;
                } else {
                    return true;
                }
            })
        );
    };
}
